$bp-breakpoint-xs: 0;
$bp-breakpoint-s: 414px;
$bp-breakpoint-m: 768px;
$bp-breakpoint-l: 960px;
$bp-breakpoint-xl: 1120px;

:host {
    padding: 30px 20px;
    @media (min-width: 768px) {
        padding: 30px 64px;
    }
 
    @media (min-width: 1328px){
        max-width: 1200px;
    }

    margin: 0 auto;
   
    display: block;
}
